import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        list_partners: {
          tracker_settings: {
            tabs: {
              trackers: {
                fixed_tracker_payments: {
                  header: 'HEADER',
                  form: {
                    merchant_name: 'MERCHANT_NAME_LABEL',
                    serial_id: 'SERIAL_ID_LABEL',
                    payment_size: 'PAYMENT_SIZE_LABEL',
                    date: 'DATE_LABEL',
                    description: 'DESCRIPTION_LABEL',
                    submit: 'SUBMIT_BUTTON',
                  },
                },
              },
            },
          },
        },
      },
    },
  }));
}
